import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Configuration } from "../configurations/shared.config";

@Injectable()
export class PanicRoleService {

    constructor(private http: Http) { }

    getCurrentStaff() {
        return this.http.get(Configuration.urls.webApiEndpoint + Configuration.urls.CurrentStaffPanicRole)
            .map(res => res.json());
    }

    ResolvePanic(panicObject: any) {
        return this.http.post(Configuration.urls.webApiEndpoint + Configuration.urls.PanicResolve, panicObject).map(res => res.json());
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/PanicRole.service.ts